import { initSentryBrowser } from '@nrx/error-tracking-web';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app.js';
import { DocsThemeProvider } from './theme/docs-theme-provider.js';
import './index.css';

// Sentry must initialise before the app renders (mirrors the backend instrument-first rule).
initSentryBrowser({
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  environment: import.meta.env['VITE_SENTRY_ENVIRONMENT'],
  release: import.meta.env['VITE_SENTRY_RELEASE'],
  app: 'design-system',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <DocsThemeProvider>
      <App />
    </DocsThemeProvider>
  </React.StrictMode>,
);
